import React, { useState, useEffect } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { Broker } from 'models';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { COLOR, isDev } from 'config/constants';
import { HvButton } from 'components';
import $ from 'jquery';
import PortalHeader from './PortalHeader';

const useStyles = makeStyles({
  banner: {
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 30,
  },
  bannerImage: {
    width: '100%',
    height: 'calc(100vh - 80px)',
    objectFit: 'cover',
    alignSelf: 'center',
    '@media (max-width: 700px)': {
      height: 400,
    },
  },
  bannerImageContainer: {
    width: '100%',
    height: 'calc(100vh - 80px)',
    '@media (max-width: 700px)': {
      height: 400,
    },
  },
  slogan: {
    fontWeight: 'bold',
    fontSize: 35,
    marginBottom: 50,
    color: COLOR.WHITE,
    '@media (max-width: 700px)': {
      fontSize: 20,
    },
  },
  addressContent: {
    position: 'absolute',
    textAlign: 'center',
    bottom: 50,
    zIndex: 3,
  },
  address: {
    color: COLOR.WHITE,
    fontSize: 20,
    '@media (max-width: 700px)': {
      fontSize: 15,
    },
  },
  overlay: {
    position: 'absolute',
    zIndex: 2,
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'black',
    opacity: 0.5,
  },
  stickyHeader: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: 'auto',
    backgroundColor: COLOR.WHITE,
    zIndex: 999,
  },
  contactButton: {
    position: 'relative',
    justifyContent: 'center',
    marginTop: 20,
  },
});
interface Props {
  broker: Broker;
  slogan: string;
  bio: string;
  profile_picture_url: string;
  banner_picture_url: string;
  logo_picture_url?: string;
  portal_infos: any;
  showcase_listings: [];
  centris_listings_from_db: [];
  sections?: any;
  showPortalHeader?: boolean;
  favorite_listings: any;
  is_white_text?: boolean;
}
function ListingsHeader(props: Props) {
  const {
    broker,
    slogan,
    bio,
    profile_picture_url,
    banner_picture_url,
    logo_picture_url,
    portal_infos,
    showcase_listings,
    centris_listings_from_db,
    sections,
    showPortalHeader,
    favorite_listings,
    is_white_text,
  } = props;
  const styles = useStyles();
  const intl = useIntl();

  const location = useLocation();
  const dev_domain_name = new URLSearchParams(location.search).get('domain_name');

  const [listingPictures, setListingPictures] = useState<any[]>([]);
  const [currentSlide, setCurrentSlide] = useState<number>(0);

  const secondary_color = portal_infos?.template_style?.secondary_color || COLOR.LIGHT_BLUE;

  const fmtContactMe = intl.formatMessage({ id: 'portal.contactMe' });

  const settings = {
    infinite: true,
    arrows: true,
    fade: true,
    dots: false,
    speed: 4000, // 4 seconds
    autoplaySpeed: 4000, // 4 seconds
    autoplay: true,
    adaptiveHeight: false,
    lazyLoad: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current, next) => {
      setTimeout(() => {
        return setCurrentSlide(next);
      }, 1500);
    },
  };
  useEffect(() => {
    const listing_pictures = [];
    showcase_listings.map((showcase_listing: any) => {
      if (showcase_listing.listing) {
        const { listing } = showcase_listing;
        const { pictures } = listing;
        if (pictures.length) {
          const foundExisting = listing_pictures.find((p) => {
            return p.picture_url === pictures[0].lightbox_URL;
          });
          if (!foundExisting) {
            const listing_url = isDev()
              ? `/listing/${listing.mls}?domain_name=${dev_domain_name}`
              : `/listing/${listing.mls}`;
            listing_pictures.push({
              id: showcase_listing.listing.id,
              address: showcase_listing.address,
              picture_url: pictures[0].lightbox_URL,
              url: listing_url,
            });
          }
        }
      } else {
        const { pictures } = showcase_listing;
        if (pictures.length) {
          const foundExisting = listing_pictures.find((p) => {
            return p.picture_url === pictures[0].url;
          });
          if (!foundExisting) {
            const found_centris_listing = centris_listings_from_db.find(
              (centris_listing_from_db: any) => {
                return centris_listing_from_db.mls === showcase_listing.mls;
              },
            );
            const { distribution_token } = found_centris_listing || {};
            const listing_url = isDev()
              ? `/listing/${showcase_listing.mls}?domain_name=${dev_domain_name}`
              : `/listing/${showcase_listing.mls}`;
            listing_pictures.push({
              id: showcase_listing.id,
              address: `${showcase_listing?.civic_number_start} ${showcase_listing.street}, ${showcase_listing?.municipality?.description}, ${showcase_listing.postalcode}`,
              picture_url: pictures[0].url,
              url: listing_url,
            });
          }
        }
      }

      return null;
    });
    setListingPictures(listing_pictures);
  }, [showcase_listings]);
  const handleListingClick = (listing) => {
    if (listing.url) {
      window.open(listing.url, '_blank');
    }
  };
  return (
    <div>
      <div className={styles.stickyHeader}>
        {showPortalHeader ? (
          <PortalHeader
            displaySocialMedia
            logo_picture_url={logo_picture_url}
            portal_infos={portal_infos}
            broker={broker}
            sections={sections}
            favorite_listings={favorite_listings}
            is_white_text={is_white_text}
          />
        ) : null}
      </div>
      <div className={styles.banner}>
        <div className={styles.bannerImageContainer}>
          <Slider {...settings}>
            {listingPictures &&
              listingPictures.map((item, index) => {
                return (
                  <div key={index}>
                    <img
                      src={item.picture_url}
                      key={index}
                      style={{ cursor: item.url ? 'pointer' : 'default' }}
                      className={styles.bannerImage}
                      alt='house'
                      onClick={() => {
                        return handleListingClick(item);
                      }}
                    />
                    <div
                      className={styles.overlay}
                      style={{ cursor: item.url ? 'pointer' : 'default' }}
                      onClick={() => {
                        return handleListingClick(item);
                      }}
                    />
                  </div>
                );
              })}
          </Slider>
        </div>
        <div className={styles.addressContent}>
          <Typography className={styles.slogan}>{slogan || null}</Typography>
          <Typography className={styles.address}>
            {listingPictures[currentSlide]?.address}
          </Typography>
          <div className={styles.contactButton}>
            <HvButton
              onClick={(e: any) => {
                e.preventDefault();
                const form = $('.section.contactform')[0];
                if (form) {
                  form.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
              }}
              style={{ backgroundColor: secondary_color }}
            >
              <Typography>{fmtContactMe}</Typography>
            </HvButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListingsHeader;
